import React from 'react'
import Button from './index'

const DuplicateButton = ({ onClick }) => {
  return (
    <Button
      type="button"
      btnClass="btn-icon"
      iconRight
      iconSize="1rem"
      iconClass="pi pi-copy"
      onHandleClick={onClick}
    />
  )
}

export default DuplicateButton
